import React from 'react'
import { useI18n } from 'contexts/i18n'
import { safeFormat } from 'utilities/date-time'
import { Button, Time } from './s'
import FileNameIcon from 'components/file-name-icon'

const DocumentReference = ({ dokument, preview }) => {
    const { dateLocale: locale } = useI18n()

    const {
        name,
        extension,
        type,
        uploadedAt
    } = dokument

    return (
        <Button onClick={() => preview(dokument)}>
            <FileNameIcon
                name={name}
                extension={extension ?? type} />
            {uploadedAt && (
                <Time>{safeFormat(uploadedAt, 'PPP', { locale })}</Time>
            )}
        </Button>
    )
}

export default DocumentReference